import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
import { createInventoryInfovalidation } from "../../validation/InventoryInfo";
import Form from "../InventoryInfo/Form";
import Button from "../Reusable/Button";

const AddInventoryPopup = (props: any) => {
  const {
    setOpenCategoryFormPopup,
    setOpenInventoryFormPop,
    setOpenUnitFormPopup,
    partyValue,
    setItems = null,
  } = props;
  const {
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
    register,
    setError,
    watch,
    control,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(createInventoryInfovalidation),
  });
  const openingQuantity = watch("opening_quantity");
  const openingRate = watch("opening_rate");

  useEffect(() => {
    const quantity = parseFloat(openingQuantity);
    const rate = parseFloat(openingRate);
    if (!isNaN(quantity) && !isNaN(rate)) {
      const openingValue = quantity * rate;
      setValue("opening_balance", openingValue);
    } else {
      setValue("opening_balance", "");
    }
  }, [openingQuantity, openingRate]);

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["inventory-info"],
    navigateURL: "",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.PRODUCT}`;
    const formData = {
      ...values,
      is_group: false,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        if (setItems) {
          setItems(`items.${partyValue}.account`, res?.data);
          setItems(`items.${partyValue}.hs_code`, res?.data?.hs_code);
          setItems(`items.${partyValue}.unit`, res?.data?.unit?.name);
          setItems(`items.${partyValue}.is_taxable`, res?.data?.is_taxable);
        }
        setOpenInventoryFormPop(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit((data) => handleCreate(data, setError))}
        className={tw`px-4`}
      >
        <Form
          control={control}
          register={register}
          errors={errors}
          setValue={setValue}
          watch={watch}
          setOpenCategoryFormPopup={setOpenCategoryFormPopup}
          setOpenUnitFormPopup={setOpenUnitFormPopup}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <div className={tw`flex w-full justify-end`}>
          <div className={tw`w-24 flex gap-x-4 items-center`}>
            <Button label="Save" isLoading={isPostLoading} />
          </div>
        </div>
      </form>
    </>
  );
};

export default AddInventoryPopup;
